"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useRenderAttachment;

var _useWebChatAPIContext2 = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useRenderAttachment() {
  var _useWebChatAPIContext = (0, _useWebChatAPIContext2.default)(),
      attachmentRenderer = _useWebChatAPIContext.attachmentRenderer;

  return attachmentRenderer;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VSZW5kZXJBdHRhY2htZW50LmpzIl0sIm5hbWVzIjpbInVzZVJlbmRlckF0dGFjaG1lbnQiLCJhdHRhY2htZW50UmVuZGVyZXIiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7OztBQUVlLFNBQVNBLG1CQUFULEdBQStCO0FBQzVDLDhCQUErQixxQ0FBL0I7QUFBQSxNQUFRQyxrQkFBUix5QkFBUUEsa0JBQVI7O0FBRUEsU0FBT0Esa0JBQVA7QUFDRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHVzZVdlYkNoYXRBUElDb250ZXh0IGZyb20gJy4vaW50ZXJuYWwvdXNlV2ViQ2hhdEFQSUNvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VSZW5kZXJBdHRhY2htZW50KCkge1xuICBjb25zdCB7IGF0dGFjaG1lbnRSZW5kZXJlciB9ID0gdXNlV2ViQ2hhdEFQSUNvbnRleHQoKTtcblxuICByZXR1cm4gYXR0YWNobWVudFJlbmRlcmVyO1xufVxuIl19